import React from 'react';
// import queryParameterUtils from '../../utils/query-parameter-utils';
// import cookieUtils from '../../infrastructure/cookie/cookie-utils';
// import authenticationService from '../../services/authentication-service';
// import redirectUtils from '../../utils/redirect-utils';

// const addQueryParam = (url, key, value) => url + (url.indexOf('?') < 0 ? '?' : '&') +
//   encodeURIComponent(key) + '=' + encodeURIComponent(value);

// const authenticate = () => {
//   const shopQueryParameter = queryParameterUtils.tryFindQueryParameter('shop');
//   const userIdCookie = cookieUtils.getCookie('user_id');
//   if (!shopQueryParameter) {
//     if (userIdCookie) {
//       return redirectUtils.redirectTo(addQueryParam(window.location.href, userIdCookie));
//     } else {
//       return authenticationService.redirectToLoginUrl();
//     }
//   } else {
//
//   }
// };

const withAuthentication = Comp => {
   const CompWithAuthentication = props => {
     return <Comp {...props} />;
  };
  return CompWithAuthentication;
};

export {withAuthentication};
